import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  status: 'idle',
  error: null,
  failureKind: null,
  supportEmail: null,
  courseId: null,
  courseDetail: null,
  tasks: [],
  callHistory: [],
  submission: { scheduleId: null, status: 'idle', error: null },
  reschedule:  { scheduleId: null, status: 'idle', error: null },
  intake:      { status: 'idle', error: null },
};

const slice = createSlice({
  name: 'coaching',
  initialState,
  reducers: {
    coachingPageRequested(state, action) {
      state.status = 'loading';
      state.courseId = action.payload.courseId;
      state.error = null;
      state.failureKind = null;
      state.supportEmail = null;
    },
    coachingPageLoaded(state, action) {
      state.status = 'ready';
      state.courseDetail = action.payload.courseDetail;
      state.tasks = action.payload.tasks ?? [];
      state.callHistory = action.payload.callHistory ?? [];
      state.error = null;
      state.failureKind = null;
      state.supportEmail = null;
    },
    coachingPageFailed(state, action) {
      state.status = 'failed';
      const failure = typeof action.payload === 'string'
        ? { message: action.payload }
        : (action.payload ?? {});
      state.error = failure.message ?? 'Failed to load coaching';
      state.failureKind = failure.kind ?? 'generic';
      state.supportEmail = failure.supportEmail ?? null;
    },
    coachingCleared() {
      return initialState;
    },
    tasksRefreshed(state, action) {
      state.tasks = action.payload ?? [];
    },
    courseDetailRefreshed(state, action) {
      state.courseDetail = action.payload;
    },
    callHistoryRefreshed(state, action) {
      state.callHistory = action.payload ?? [];
    },
    assignmentSubmitting(state, action) {
      state.submission = { scheduleId: action.payload.scheduleId, status: 'submitting', error: null };
    },
    assignmentSubmitted(state) {
      state.submission = { scheduleId: null, status: 'submitted', error: null };
    },
    assignmentSubmitFailed(state, action) {
      state.submission = { ...state.submission, status: 'failed', error: action.payload ?? 'Submit failed' };
    },
    rescheduleRequested(state, action) {
      state.reschedule = { scheduleId: action.payload.scheduleId, status: 'submitting', error: null };
    },
    rescheduleSubmitted(state) {
      state.reschedule = { scheduleId: null, status: 'submitted', error: null };
    },
    rescheduleFailed(state, action) {
      state.reschedule = { ...state.reschedule, status: 'failed', error: action.payload ?? 'Reschedule failed' };
    },
    intakeSubmitting(state) {
      state.intake = { status: 'submitting', error: null };
    },
    intakeSubmitted(state) {
      state.intake = { status: 'submitted', error: null };
    },
    intakeFailed(state, action) {
      state.intake = { status: 'failed', error: action.payload ?? 'Intake submit failed' };
    },
  },
});

export const {
  coachingPageRequested,
  coachingPageLoaded,
  coachingPageFailed,
  coachingCleared,
  tasksRefreshed,
  courseDetailRefreshed,
  callHistoryRefreshed,
  assignmentSubmitting,
  assignmentSubmitted,
  assignmentSubmitFailed,
  rescheduleRequested,
  rescheduleSubmitted,
  rescheduleFailed,
  intakeSubmitting,
  intakeSubmitted,
  intakeFailed,
} = slice.actions;

export const coachingReducer = slice.reducer;
